
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.175 20.263c.232 0 .427-.08.586-.238a.797.797 0 00.239-.586.777.777 0 00-.174-.497 1.03 1.03 0 00-.412-.318 1.56 1.56 0 01-.84-.79c-.169-.361-.209-.76-.12-1.193.09-.434.33-.843.721-1.227.146-.133.282-.277.408-.433.126-.155.225-.344.298-.566.073-.222.11-.489.11-.8V3.03c0-1-.251-1.756-.751-2.266S13.992 0 12.999 0H2.99C2.004 0 1.26.255.755.765.252 1.275 0 2.031 0 3.031v14.241c0 .994.25 1.74.75 2.241.5.5 1.24.75 2.221.75h12.204zM4.105 1.72h8.765c.477 0 .833.119 1.068.357.235.239.353.583.353 1.034v10.256c0 .496-.259.745-.776.745h-9.41V1.72zM1.708 14.47V3.11c0-.45.118-.794.353-1.033.177-.179.417-.29.722-.335l.028-.003V14.13l-.05.004c-.134.015-.261.037-.382.067-.242.06-.465.15-.67.269zm11.449 4.144H3.15c-.497 0-.87-.128-1.118-.383-.248-.255-.372-.608-.372-1.058 0-.418.139-.757.417-1.019.278-.262.66-.393 1.143-.393h9.51c.06 0 .115-.003.164-.01l.154-.02a3.09 3.09 0 00-.308 1.501c.027.51.166.97.418 1.382z","fill":"#AAB4C0"}})])
          )
        }
      }
    